module.exports = __webpack_public_path__ + "img/cockfight-menu-bg.bdb3a962.svg";